module.exports = __webpack_public_path__ + "images/collections/collections-grey.5ebebc0a66b74d9246ce.svg";


//////////////////
// WEBPACK FOOTER
// ./resources/images/collections/collections-grey.svg
// module id = 53yk
// module chunks = 0